/** Questions already in play, from the round snapshot — not the current list length. */
export function triviaLockedQuestionCount(data: {
  status?: string | null;
  playedThroughIndex?: number | null;
  questionIndex?: number | null;
}): number {
  if (!data.status || data.status === 'IDLE') {
    return 0;
  }
  return Math.max(data.playedThroughIndex ?? -1, data.questionIndex ?? 0) + 1;
}
